import { includes, isNil } from 'lodash'
import { FieldValues, UseFormGetValues } from 'react-hook-form'

import { SchemaAttributes, EnumValue } from '@/Data/typesV2'
import {
  getLocalizedSchemaAttributes,
  getLocalizedSchemaEnumValues,
} from '@/utils/schemaLocalization'

export const getDataClassEnumSelectArray = (
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  getValues: UseFormGetValues<FieldValues> | ((key: string) => any),
  enumValues?: EnumValue[],
  schemaAttributes?: SchemaAttributes,
  limitEnumValuesTo?: string[],
) => {
  const localizedEnumValues = getLocalizedSchemaEnumValues(enumValues)
  const localizedSchemaAttributes =
    getLocalizedSchemaAttributes(schemaAttributes)

  const options = localizedEnumValues?.flatMap((e) => {
    if (e.readonly) {
      return []
    }

    if (!isNil(limitEnumValuesTo)) {
      if (!includes(limitEnumValuesTo, e.value)) {
        return []
      }
    }

    if (!e.constraints) {
      return {
        value: e.value,
        label: e.title,
      }
    }

    const keys = Object.keys(e.constraints)

    return keys.flatMap((key) => {
      if (key === 'isExternal') {
        return { value: e.value, label: e.title }
      }
      if (
        localizedSchemaAttributes?.[key]?.readonly &&
        !localizedSchemaAttributes?.[key]?.mandatory
      ) {
        return { value: e.value, label: e.title }
      }
      if (e.constraints?.[key]?.includes(getValues(key))) {
        return { value: e.value, label: e.title }
      }
      return []
    })
  })

  return options
}
